
// Component to render a single score. Shows a list of the traits and their assigned values

// Requires a score and rubric to be passed in.

<template>
	<div class="box mb-0" :class="{ rubric: !compareScore }">
		<table class="table mb-0">
			<tbody>
				<tr>
					<td>
						<span class="d-flex flex-row align-items-center">
							<i v-if="scoreTypeIconClass" class="fas mr-1" :class="scoreTypeIconClass"></i>
							<i
								v-if="!scoreTypeIconClass"
								class="material-icons mr-1"
								style="font-size: 20px; line-height: 22px;"
								>{{ scoreTypeIcon }}</i
							>
							<strong>{{ scoreTypeStr }}</strong>
						</span>
					</td>
					<td>
						<span
							v-if="hasUser && mut_score.user.scorer_id"
							v-tippy
							:title="mut_score.user.first_name + ' ' + mut_score.user.last_name"
							>{{ mut_score.user.scorer_id }}</span
						>
						<span v-if="hasUser && !mut_score.user.scorer_id"
							>{{ mut_score.user.first_name }} {{ mut_score.user.last_name }}</span
						>
					</td>
				</tr>
				<tr v-if="!hideTime">
					<td colspan="3">
						<i class="fal fa-clock"></i>
						{{ format(mut_score.created_at) }}
					</td>
				</tr>
				<tr v-if="compareScore">
					<td class="text-xs text-muted">{{ numAgreed }}/{{ numTraits }}</td>
					<td class="text-xs text-muted">Scored</td>
					<td class="text-xs text-muted">Actual</td>
				</tr>
				<tr
					v-for="mt in mut_score.meta_trait_scores"
					:key="mt.meta_trait_id"
					v-if="!compareScore && (mt.value != '' || isRequiredMetaTrait(mt))"
				>
					<td class="v-mid">
						<span class="text-muted">{{ getMetaTraitName(mt) }}:</span>
					</td>
					<td class="v-mid">
						<span class="p-1 position-relative">{{ mt.value }}</span>
					</td>
				</tr>
				<template v-if="!loading" v-for="(ts, i) in mut_score.trait_scores">
					<tr :key="`score-${i}`">
						<td class="v-mid">
							<strong>{{ getTraitName(ts) }}</strong>
						</td>
						<td class="v-mid">
							<span
								class="p-1 position-relative"
								:class="{
									disagreed: ts.disagreed,
									nonadj: ts.nonadj,
									adjacent: ts.adj,
									'text-extra-muted': getScore(ts) == '?'
								}"
							>
								{{ getScore(ts) }}
								<i v-if="ts.disagreed < -1" class="far fa-chevron-double-down text-muted"></i>
								<i v-if="ts.disagreed == -1" class="far fa-chevron-down text-muted"></i>
								<i v-if="ts.disagreed == 1" class="far fa-chevron-up text-muted"></i>
								<i v-if="ts.disagreed > 1" class="far fa-chevron-double-up text-muted"></i>
							</span>
						</td>
						<td v-if="compareScore">{{ getCompareScore(ts) }}</td>
					</tr>
					<tr v-if="ts.evidence && !compareScore" :key="`evidence-${i}`">
						<td class="text-muted">Evidence:</td>
						<td colspan="2">{{ ts.evidence }}</td>
					</tr>
				</template>
				<tr v-if="loading">
					<td>
						<loading v-if="!loadingError" type="header" />
						<div v-if="loadingError">Error</div>
					</td>
				</tr>
			</tbody>
		</table>
	</div>

	<!-- <div class="list-group list-group-alt box rubric">

		
		<p>Score Type: {{score_type}}</p>

		<a href="#" v-for="ts in mut_score.trait_scores" :key="ts.trait_id" class="list-group-item">
			{{getTraitName(ts)}}
			<span class="float-right">{{getScore(ts)}}</span>
		</a>

		
	</div>-->
</template>

<script>
import Utils from "@/services/Utils";
import ItemService from "@/services/ItemService";
import fs from "@/services/FormatService";
import moment from "moment";

export default {
	name: "Score",
	props: {
		score: {
			default: null
		},
		compareScore: {
			default: null
		},
		rubric: {
			default: null
		},
		itemID: {
			default: null
		},
		type: {
			type: Number,
			default: null
		},
		reset: {
			default: null
		},
		hideTime: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			fs: fs,
			mut_score: _.cloneDeep(this.score),
			mut_rubric: _.cloneDeep(this.rubric),
			score_type: this.score.score_type,
			can_reset: this.reset,
			loading: false,
			loadingError: null,

			numAgreed: 0,
			numTraits: 0
		};
	},
	created() {
		if (this.compareScore) {
			this.checkAgreement(this.mut_score, this.compareScore);
		}
	},
	mounted() {
		if (!this.rubric && this.itemID) {
			this.loading = true;
			ItemService.getItem(this.itemID)
				.then(resp => {
					console.log("respoooooooo ",resp)
					this.mut_rubric = resp.data.rubric;
				})
				.catch(err => {
					this.loadingError = true;
				})
				.finally(() => {
					this.loading = false;
				});
		}
	},
	computed: {
		scoreTypeIcon() {
			return fs.scoreTypeIcon(this.score_type || this.type);
		},
		scoreTypeIconClass() {
			return fs.scoreTypeIconClass(this.score_type || this.type);
		},
		scoreTypeStr() {
			let ret = fs.scoreTypeName(this.score_type || this.type);
			if (this.hasUser) {
				return `${ret}:`;
			} else {
				return ret;
			}
		},
		hasUser() {
			if (!this.mut_score) {
				return false;
			}
			if (!this.mut_score.user) {
				return false;
			}
			return this.mut_score.user.full_name;
		}
	},
	watch: {
		score() {
			this.mut_score = _.cloneDeep(this.score);
		},
		compareScore() {
			if (this.compareScore) {
				this.checkAgreement(this.mut_score, this.compareScore);
			}
		},
		rubric() {
			this.mut_rubric = _.cloneDeep(this.rubric);
		}
	},
	methods: {
		getTraitName(trait_score) {
			if (this.mut_rubric) {
				var trait = _.find(this.mut_rubric.traits, {
					id: trait_score.trait_id
				});
				if (trait) {
					return trait.name;
				}
			}

			return "——";
		},
		getMetaTraitName(meta_trait) {
			if (this.mut_rubric) {
				var trait = _.find(this.mut_rubric.meta_traits, {
					id: meta_trait.meta_trait_id
				});
				if (trait) {
					return trait.name;
				}
			}

			return "——";
		},
		isRequiredMetaTrait(meta_trait) {
			if (this.mut_rubric) {
				var trait = _.find(this.mut_rubric.meta_traits, {
					id: meta_trait.meta_trait_id
				});
				if (trait) {
					return trait.required;
				}
			}

			return false;
		},
		checkAgreement(score, actual) {
			this.numAgreed = 0;
			this.numTraits = 0;
			_.each(score.trait_scores, ts => {
				let comp = _.find(actual.trait_scores, {
					trait_id: ts.trait_id
				});
				if (comp && ts.score != comp.score) {
					ts.disagreed = ts.score - comp.score;
					if (Math.abs(ts.disagreed) > 1) {
						ts.nonadj = true;
					}
					if (Math.abs(ts.disagreed) == 1) {
						ts.adj = true;
					}
				} else {
					this.numAgreed++;
				}
				this.numTraits++;
			});
		},
		getScore(ts) {
			if (ts.score >= 0) {
				return ts.score;
			} else {
				return ts.condition;
			}
		},
		getCompareScore(ts) {
			let comp = _.find(this.compareScore.trait_scores, {
				trait_id: ts.trait_id
			});
			if (comp) {
				if (comp.score >= 0) {
					return comp.score;
				} else {
					return comp.condition;
				}
			} else {
				return "——";
			}
		},
		format(date) {
			return moment(date).format("MM/DD/YY h:mm:ss a");
		},
		resetScore() {
			this.$emit("on-reset", this.score);
		}
	}
};
</script>

<style scoped>
.list-group-item:hover {
	background-color: rgba(0, 0, 0, 0.05);
}
.disagreed {
	background-color: rgb(255, 0, 0, 0.2);
	border-radius: 0.5rem;
}
.adjacent {
	background-color: rgba(253, 168, 41, 0.25);
}
</style>



// WEBPACK FOOTER //
// src/components/Score.vue